import React from "react";
import { Link } from "react-router-dom";
import Reveal from "./Reveal";
export default function ContactCTA() {
  return (
    <section className="contact-cta">
      <div className="container">
        <Reveal>
          <p className="eyebrow">LET’S BUILD THE NEXT.</p>
          <Link to="/contact" className="contact-cta__link">
            <h2>
              次のビジネスを、
              <br />
              RYUと。
            </h2>
            <span aria-hidden="true">↗</span>
          </Link>
          <div className="contact-cta__bottom">
            <p>法人取引・仕入れ・商品提案・販売のご相談</p>
            <Link to="/contact">
              お問い合わせ <span>↗</span>
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
